import React from 'react';
import { Text } from '@react-pdf/renderer';
const CategoryTitle = ({ categoryTitle }) => {
    if (!categoryTitle)
        return null;
    return (React.createElement(Text, { style: { fontSize: '12px', borderBottom: '1px solid #EAEAEA', marginBottom: '8px', paddingBottom: '8px' } }, categoryTitle));
};
export default CategoryTitle;
